import { render, staticRenderFns } from "./LandPageSearchSenff.vue?vue&type=template&id=247285fa&scoped=true"
import script from "./LandPageSearchSenff.vue?vue&type=script&lang=js"
export * from "./LandPageSearchSenff.vue?vue&type=script&lang=js"
import style0 from "./LandPageSearchSenff.vue?vue&type=style&index=0&id=247285fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247285fa",
  null
  
)

export default component.exports